import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import BCXCheckbox from '@/components/molecules/forms/BCXCheckbox.vue';
import useUser from '@/mixins/useUser';
import { storeConsentStatusEntry, getDocumentPdf } from '@/services/AgbService';
import VueI18n from '@/i18n';
import BannerDesktop from '@/assets/svg/company-consent-banner-desktop.svg?inline';
import BannerMobile from '@/assets/svg/company-consent-banner-mobile.svg?inline';
import BulletStar from '@/assets/svg/bullet-star-s.svg?inline';
import BulletCheck from '@/assets/svg/bullet-check-s.svg?inline';
import IconDownload from '@/components/svg/download-circle.svg?inline';
import IconView from '@/components/svg/view-2.svg?inline';
import { ConsentStatusType } from '@/models/ConsentStatusType';
import usePopupState from '@/state/usePopupState';
import BCXMarkdown from '@/components/molecules/BCXMarkdown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCompanyConsentCheck',
  props: {
    latestServiceUsageAgreementVersion: null,
    latestPriceListVersion: null
  },
  emits: ['consented'],
  setup(__props: any, { emit }) {

const props = __props as {
  latestServiceUsageAgreementVersion: string;
  latestPriceListVersion: string;
};





const { tUserFallback } = useUser('self');

const { setPdf, showPopup, hidePopup } = usePopupState();

const isAccepting = ref(false);
const hasAcceptedCheckbox = ref(false);

const t = (key: string) => tUserFallback(`project-forum_USERTYPE.company-consent.${key}`);

const advantages = computed(() => {
  const result = VueI18n.t('project-forum.company-consent.advantages');
  return Array.isArray(result) ? result : [];
});

const costs = computed(() => {
  const result = VueI18n.t('project-forum.company-consent.costs');
  return Array.isArray(result) ? result : [];
});

const download = async (type: ConsentStatusType, filename: string, documentVersion: string) => {
  try {
    const blob = await getDocumentPdf(type, documentVersion);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (e) {
    console.error('Download failed', e);
  }
};

const viewConsentDocument = async (type: ConsentStatusType, version: string) => {
  try {
    showPopup();
    const blob = await getDocumentPdf(type, version);
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64 = (reader.result as string).split(',')[1];
      const filename = type === ConsentStatusType.PRICE_LIST ? 'Preisliste.pdf' : 'Nutzungsvereinbarung.pdf';
      setPdf(base64, filename);
    };
  } catch (error) {
    console.error('View service usage agreement failed', error);
    hidePopup();
  }
};

const onAccept = async () => {
  if (!hasAcceptedCheckbox.value) return;

  isAccepting.value = true;
  try {
    await storeConsentStatusEntry(ConsentStatusType.SERVICE_USAGE_AGREEMENT, props.latestServiceUsageAgreementVersion, 'ACCEPTED');
    await storeConsentStatusEntry(ConsentStatusType.PRICE_LIST, props.latestPriceListVersion, 'ACCEPTED');
    emit('consented');
  } catch (error) {
    console.error('Error accepting company consents', error);
  } finally {
    isAccepting.value = false;
  }
};

return { __sfc: true,props, emit, tUserFallback, setPdf, showPopup, hidePopup, isAccepting, hasAcceptedCheckbox, t, advantages, costs, download, viewConsentDocument, onAccept, BCXCheckbox, BannerDesktop, BannerMobile, BulletStar, BulletCheck, IconDownload, IconView, ConsentStatusType, BCXMarkdown }
}

})